import { Menu, Table } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  border-right: none;
  padding-left: 12px;
  .ant-menu-sub.ant-menu-inline {
    background: none;
  }
  .ant-menu-submenu {
    overflow: hidden;
  }
  .ant-menu-item {
    margin: 6px 0;
    height: 26px !important;
    line-height: 26px !important;
    border-radius: 8px 0px 0px 8px;
    color: #000000;
  }
  .ant-menu-submenu-title {
    margin: 6px 0;
    padding-right: 22px !important;
    height: 26px !important;
    line-height: 26px !important;
    color: #000000;
  }
  .ant-menu-sub .ant-menu-submenu .ant-menu-submenu-title {
    color: #525252;
  }
  .ant-menu-sub .ant-menu-submenu .ant-menu-item {
    color: #525252;
  }
  .ant-menu-submenu-title:hover {
    color: #0494e6 !important;
  }
  .ant-menu-sub .ant-menu-submenu .ant-menu-item:hover {
    color: #0494e6 !important;
  }
  .ant-menu-item-selected {
    background: #e8f5fc !important;
    color: #0494e6 !important;
    font-weight: bold;
  }
  .ant-menu-item-selected::after {
    display: none;
  }
`;

export const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    padding: 12px 16px;
    background: #f0f2f7;
    font-weight: bold;
  }
  .ant-table-thead > tr > th::before {
    display: none;
  }
  table {
    border-radius: 10px;
  }
  .ant-table-container {
    border-radius: 10px;
  }
  .ant-table-body::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .ant-table-body::-webkit-scrollbar-track {
    background: transparent;
  }
  .ant-table-body::-webkit-scrollbar-thumb {
    background: #d8d8d8;
    border-radius: 4px;
  }
  .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .ant-table-container table > thead > tr th {
    border-right: 0 !important;
  }
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }
  .ant-table-container table > tbody > tr:first-child td:first-child {
    border-bottom-left-radius: 10px;
  }
  .ant-table-container table > tbody > tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: none;
  }
  .ant-table-tbody > tr > td {
    vertical-align: middle;
    padding: 20px 16px;
  }
`;

export const StyledTable2 = styled(Table)`
  .ant-table-thead > tr > th {
    padding: 12px 16px;
    background: #f0f2f7;
    font-weight: bold;
  }
  .ant-table-thead > tr > th::before {
    display: none;
  }
  table {
    border-radius: 0;
  }
  .ant-table-container {
    border-radius: 0;
  }
  .ant-table-container table > thead > tr th {
    border-right: 0 !important;
  }
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 0;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 0;
  }
  .ant-table-container table > tbody > tr:first-child td:first-child {
    border-bottom-left-radius: 0;
  }
  .ant-table-container table > tbody > tr:last-child td:last-child {
    border-bottom-right-radius: 0;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: none;
  }
  .ant-table-tbody > tr > td {
    vertical-align: middle;
    padding: 20px 16px;
  }
`;
